export default {
  data: {
    searchPageSize: 12,
    searchCurrentPage: 1,
    totalPages: 1,
    items: [],
  },
};
